import type {GradientPalette} from '../types';
import {PALETTE_ID} from '../types';

export default {
    id: PALETTE_ID.GOLDEN_20,
    scheme: [
        '#FDEC4D',
        '#FDDE43',
        '#FDD039',
        '#FDBF2F',
        '#FDAE25',
        '#FD9B1B',
        '#FD8711',
        '#FD7207',
        '#F75C02',
        '#ED4902',
        '#E33702',
        '#D92602',
        '#CF1702',
        '#C40802',
        '#BA0208',
        '#B00213',
        '#A6021D',
        '#9C0125',
        '#92012D',
        '#880132',
    ],
    gradient: true,
} as GradientPalette;
